import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ContainerComponent } from '../../../shared/components/container/container.component';
import { GlobalButtonComponent } from '../../../shared/components/global-button/global-button.component';
import { PictureComponent } from '../../../shared/components/picture/picture.component';

@Component({
  selector: '[hcp-resources]',
  imports: [ContainerComponent, PictureComponent, GlobalButtonComponent],
  templateUrl: './hcp-resources.html',
  styleUrl: './hcp-resources.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    id: 'hcp-resources',
  },
})
export class HcpResources {}
